import { useTheme, useMediaQuery } from '@mui/material';
import ContribuenteDetailPageDesktop from './ContribuenteDetailPageDesktop';
import ContribuenteDetailPageMobile from './ContribuenteDetailPageMobile';

export default function DocumentiListPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile
    ? <ContribuenteDetailPageMobile />
    : <ContribuenteDetailPageDesktop />;
}